import React, {Component, ReactElement, ReactNode} from 'react'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    ADMINISTORATOR_MODE,
    EVENT_CATEGORY,
    EVENT_ITEM_CLEANING,
    EVENT_ITEM_GARBAGE_DAY,
    EVENT_ITEM_MAINTENANCE,
    EVENT_ITEM_OTHER,
    EVENT_ITEM_OTHER_EVENTS,
    EVENT_REPEAT_DAY,
    EVENT_REPEAT_DAY_OF_THE_WEEK,
    EVENT_REPEAT_UNIT,
    EVENT_REPEAT_UNIT_FOR_WEEK,
    EVENT_REPEAT_WEEK,
    EVENT_TERM_TYPE,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    SELECT_CONDOMINIUM_TYPE,
} from '../../../CodeMaster';
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage';
import {Nullable} from '../../../app/TypeHelpers';
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo';
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup';
import styled from 'styled-components';
import PPDatePicker from '../../../components/shared/forms/PPDatePicker';
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents';
import {ColorResult, SketchPicker} from 'react-color';
import {StyledDiv, StyledLabel, StyledSpan, StyledUl} from '../../../styledComponents/StyledTypeDefinitions';
import {Button, Dialog, DialogActions, Table, TableBody, TableCell, TableRow} from '@mui/material';
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup';
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin';
import NatScheduleRepo from './repository/NatScheduleRepo';
import {ScheduleNotDeliveryCondominiumList} from './repository/NatPostSchedule';
import {
    NatGetSchedule,
    ScheduleNotDeliveryCondominiumList as DeliveryCondominiumList,
} from './repository/NatGetSchedule'
import {NatPutSchedule, NatPutScheduleParams} from './repository/NatPutSchedule'
import {formatForDateInput} from '../../../formatters/formatDate'
import {Colors, FontWeights} from '../../../styledComponents/Constants'
import {getYearAfterNextDate, getYearDate} from '../../common/util/Natutil'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import PPInput from '../../../components/shared/forms/PPInput'
import PPErrorDisplayButton from '../../../components/shared/forms/PPErrorDisplayButton'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import NatDeliveryTargetAreaSelectionComponent from '../common/admin/NatDeliveryTargetAreaSelectionComponent'
import {SortOrder} from '../../../components/shared/SortOrder'
import PPErrorLabel from '../../../components/shared/forms/PPErrorLabel'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

interface Props {
    scheduleId: string
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    scheduleRepo: NatScheduleRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    selectedExcludeCondominiumInfo: DeliveryCondominiumList[]
    selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]
    deliveryTargetPrefectureCd: string
    deliveryTargetAddress2: string
    eventCategory: string
    eventItem: string
    title: string
    barColorSetting: string
    tmpBarColor: string
    eventTermType: string
    dateOfEvent: string
    scheduleStartDate: string
    scheduleEndDate: string
    scheduleStartDateMin: string
    scheduleStartDateMax: string
    scheduleEndDateMin: string
    scheduleEndDateMax: string
    eventRepeatUnit: string
    repeatWeekUnit: string
    repeatWeek: RepeatWeek[]
    repeatDateOfTheWeek: RepeatWeek[]
    repeatDate: string
    description: string
    version: number
    isLoadCompleted: boolean
    dialogOpenSelectExcludeCondominium: boolean
    dialogOpenSelectDeliveryTargetArea: boolean
    open: boolean,
    selectedCondomoniumGroupId: number | null
    loginUserCondominiumGroupId: number | null
    selectedMaxDateTime: string
}

interface RepeatWeek {
    id: string
    label: string
    checked: boolean
    displayOrder: number,
}

class NatAdminScheduleUpdatePage extends Component<Props & AdminPagePropsSet, States> {
    administratorMode: Nullable<string>
    initialrepeatWeek: string
    initialrepeatDateOfTheWeek: string
    initialMinDate: string
    initialMaxDate: string
    initialStartDate: string
    initialEndDate: string

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)


        // イベント繰り返し週
        const repeatWeek: RepeatWeek[] = []
        EVENT_REPEAT_WEEK.values().map((repeatUnitWeek) => (
            repeatWeek.push(
                {
                    id: repeatUnitWeek.value,
                    label: repeatUnitWeek.label,
                    checked: false,
                    displayOrder: repeatUnitWeek.displayOrder,
                },
            )
        ))
        // イベント繰り返し曜日
        const repeatDateOfTheWeek: RepeatWeek[] = []
        EVENT_REPEAT_DAY_OF_THE_WEEK.values().map((repeatDayOfTheWeek) => (
            repeatDateOfTheWeek.push(
                {
                    id: repeatDayOfTheWeek.value,
                    label: repeatDayOfTheWeek.label,
                    checked: false,
                    displayOrder: repeatDayOfTheWeek.displayOrder,
                },
            )
        ))
        repeatDateOfTheWeek.push({
            id: 'ALL',
            label: '全ての曜日にチェック',
            checked: false,
            displayOrder: 99,
        })

        this.state = {
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            selectedDeliveryTargetCondominiumInfo: [],
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            eventCategory: EVENT_CATEGORY.TRASH_DAY.value,
            eventItem: '',
            title: '',
            barColorSetting: '#3a87b2',
            tmpBarColor: '#3a87b2',
            eventTermType: EVENT_TERM_TYPE.TERM.value,
            dateOfEvent: '',
            scheduleStartDate: '',
            scheduleEndDate: '',
            scheduleStartDateMin: '',
            scheduleStartDateMax: '',
            scheduleEndDateMin: '',
            scheduleEndDateMax: '',
            eventRepeatUnit: EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value,
            repeatWeekUnit: EVENT_REPEAT_UNIT_FOR_WEEK.EVERY_WEEK.value,
            repeatWeek: repeatWeek,
            repeatDateOfTheWeek: repeatDateOfTheWeek,
            repeatDate: '',
            description: '',
            version: 0,
            isLoadCompleted: false,
            dialogOpenSelectExcludeCondominium: false,
            dialogOpenSelectDeliveryTargetArea: false,
            selectedExcludeCondominiumInfo: [],
            open: false,
            selectedCondomoniumGroupId: null,
            loginUserCondominiumGroupId: loginUserCondominiumGroupId,
            selectedMaxDateTime: '',
        }
        this.administratorMode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)

        this.initialrepeatWeek = JSON.stringify(repeatWeek)
        this.initialrepeatDateOfTheWeek = JSON.stringify(repeatDateOfTheWeek)

        // システム稼働年度頭
        this.initialMinDate = ''
        // システム日付の翌々年度末
        this.initialMaxDate = ``

        this.initialStartDate = ``
        this.initialEndDate = ``

        this.handleOpenColorSetting = this.handleOpenColorSetting.bind(this)
        this.handleCancelColorSetting = this.handleCancelColorSetting.bind(this)
        this.handleOkColorSetting = this.handleOkColorSetting.bind(this)
        this.handleOpenExclusionCondominiumSelectionDialog =
            this.handleOpenExclusionCondominiumSelectionDialog.bind(this)
        this.handleCloseSelectCondominiumDiaLog = this.handleCloseSelectCondominiumDiaLog.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.renderEventRepeatUnitWeek = this.renderEventRepeatUnitWeek.bind(this)
        this.renderrepeatDateOfTheWeek = this.renderrepeatDateOfTheWeek.bind(this)
        this.onChangeEventCategory = this.onChangeEventCategory.bind(this)
        this.onChangeEventItem = this.onChangeEventItem.bind(this)
        this.onChangetitle = this.onChangetitle.bind(this)
        this.onChangeBarColor = this.onChangeBarColor.bind(this)
        this.onChangeEventTeamType = this.onChangeEventTeamType.bind(this)
        this.onChangeDayOfEvent = this.onChangeDayOfEvent.bind(this)
        this.onChangeEventStartDate = this.onChangeEventStartDate.bind(this)
        this.onChangescheduleEndDate = this.onChangescheduleEndDate.bind(this)
        this.onChangeEventRepeatUnit = this.onChangeEventRepeatUnit.bind(this)
        this.onChangeRepeatWeekUnit = this.onChangeRepeatWeekUnit.bind(this)
        this.onChangeRepeatWeek = this.onChangeRepeatWeek.bind(this)
        this.onChangeRepeatDateOfTheWeek = this.onChangeRepeatDateOfTheWeek.bind(this)
        this.onChangeRepeatDate = this.onChangeRepeatDate.bind(this)
        this.onChangeDescription = this.onChangeDescription.bind(this)
        this.getEventTermTypeRadioGroupData = this.getEventTermTypeRadioGroupData.bind(this)
        this.getEventRepeatUnitRadioGroupData = this.getEventRepeatUnitRadioGroupData.bind(this)
        this.getEventItemList = this.getEventItemList.bind(this)
        this.setSelectedExclusionCondominiumInfo = this.setSelectedExclusionCondominiumInfo.bind(this)
        this.registerScheduleButton = this.registerScheduleButton.bind(this)
        this.judgRegisterScheduleButton = this.judgRegisterScheduleButton.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.handleOpenDeliveryTargetAreaSelectionDialog = this.handleOpenDeliveryTargetAreaSelectionDialog.bind(this)
        this.handleCloseDeliveryTargetAreaSelectionDialog =
            this.handleCloseDeliveryTargetAreaSelectionDialog.bind(this)
        this.setSelectedDeliveryTargetCondominiumInfo = this.setSelectedDeliveryTargetCondominiumInfo.bind(this)
        this.setDeliveryTargetPrefectureCd = this.setDeliveryTargetPrefectureCd.bind(this)
        this.setDeliveryTargetAddress2 = this.setDeliveryTargetAddress2.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 全体モード時のみ物件グループを取得
            if (this.administratorMode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }
            }

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            let yearAfterNext: string = ''
            if (currentDateTime && currentDateTime.details) {
                yearAfterNext = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.initialMinDate = getYearDate()
                this.initialMaxDate = yearAfterNext
                this.setState({
                    selectedMaxDateTime: yearAfterNext,
                    scheduleStartDateMin: this.initialMinDate,
                    scheduleStartDateMax: this.initialMaxDate,
                    scheduleEndDateMin: this.initialMinDate,
                    scheduleEndDateMax: this.initialMaxDate,
                })
            }
            // スケジュール取得
            const schedule: Nullable<NatGetSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.getSchedule.bind(this.props.scheduleRepo, this.props.scheduleId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (schedule && schedule.details) {
                // // 繰り返し週
                const repeatWeek: RepeatWeek[] =
                    JSON.parse(this.initialrepeatWeek)
                repeatWeek.sort((a, b) => Number(b.id) - Number(a.id))
                repeatWeek.map((week) => {
                    if (schedule.details &&
                        schedule.details.repeatWeek >= Number(week.id)) {
                        week.checked = true
                        schedule.details.repeatWeek -= Number(week.id)
                    }
                })
                repeatWeek.sort((a, b) => Number(a.displayOrder) - Number(b.displayOrder))

                // 曜日指定
                const repeatDateOfTheWeek: RepeatWeek[] =
                    JSON.parse(this.initialrepeatDateOfTheWeek)
                repeatDateOfTheWeek.sort((a, b) => Number(b.id) - Number(a.id))
                repeatDateOfTheWeek.map((dayOfTheWeek) => {
                    if (dayOfTheWeek.id !== 'ALL' &&
                        schedule.details &&
                        schedule.details.repeatDayOfWeek >= Number(dayOfTheWeek.id)) {
                        dayOfTheWeek.checked = true
                        schedule.details.repeatDayOfWeek -= Number(dayOfTheWeek.id)
                    }
                })
                repeatDateOfTheWeek.sort((a, b) => Number(a.displayOrder) - Number(b.displayOrder))

                ReactDOM.flushSync(() => {
                    if (schedule && schedule.details) {
                        this.setState({
                            scheduleStartDateMin: this.initialMinDate,
                            scheduleStartDateMax: schedule.details.scheduleEndDate ?? this.initialMaxDate,
                            scheduleEndDateMin: schedule.details.scheduleStartDate,
                            scheduleEndDateMax: this.initialMaxDate,
                            eventCategory: schedule.details.eventCategory,
                            eventItem: schedule.details.eventItem,
                            title: schedule.details.title,
                            selectedExcludeCondominiumInfo: schedule.details.scheduleNotDeliveryCondominium,
                            deliveryTargetPrefectureCd: schedule.details.deliveryTargetPrefectureCd ?
                                schedule.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: schedule.details.deliveryTargetAddress2 ?
                                schedule.details.deliveryTargetAddress2 : '',
                            barColorSetting: schedule.details.barColorSetting,
                            tmpBarColor: schedule.details.barColorSetting,
                            eventTermType: schedule.details.scheduleEndDate ?
                                EVENT_TERM_TYPE.TERM.value : EVENT_TERM_TYPE.ONE_DAY.value,
                            dateOfEvent: schedule.details.scheduleStartDate,
                            scheduleStartDate: schedule.details.scheduleStartDate,
                            scheduleEndDate: schedule.details.scheduleEndDate,
                            eventRepeatUnit: !schedule.details.repeatDate ?
                                EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value : EVENT_REPEAT_UNIT.DAY.value,
                            repeatWeekUnit: schedule.details.repeatWeekUnit ?
                                schedule.details.repeatWeekUnit : EVENT_REPEAT_UNIT_FOR_WEEK.EVERY_WEEK.value,
                            repeatWeek: repeatWeek,
                            repeatDateOfTheWeek: repeatDateOfTheWeek,
                            repeatDate: schedule.details.repeatDate,
                            description: schedule.details.description,
                            version: schedule.details.version,
                            selectedCondomoniumGroupId: schedule.details.condominiumGroupId,
                        })
                    }
                })

                this.initialStartDate = schedule.details.scheduleStartDate
                this.initialEndDate = (schedule.details.scheduleEndDate) ? schedule.details.scheduleEndDate : ''
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    this.state.selectedCondomoniumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchCondition = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                selectedDeliveryTargetCondominiumInfo:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }

    handleOpenColorSetting(): void {
        this.setState({open: true})
    }

    handleCancelColorSetting(): void {
        this.setState({open: false, tmpBarColor: this.state.barColorSetting})
    }

    handleOkColorSetting(): void {
        this.setState({
            barColorSetting: this.state.tmpBarColor,
            open: false,
        })
    }

    handleOpenExclusionCondominiumSelectionDialog(): void {
        this.setState({
            dialogOpenSelectExcludeCondominium: true,
        })
    }

    handleOpenDeliveryTargetAreaSelectionDialog(): void {
        this.setState({
            dialogOpenSelectDeliveryTargetArea: true,
        })
    }

    handleCloseDeliveryTargetAreaSelectionDialog(): void {
        this.setState({dialogOpenSelectDeliveryTargetArea: false})
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    setSelectedDeliveryTargetCondominiumInfo(selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]): void {
        selectedDeliveryTargetCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedDeliveryTargetCondominiumInfo: selectedDeliveryTargetCondominiumInfo,
            dialogOpenSelectDeliveryTargetArea: false,
        })
    }

    setDeliveryTargetPrefectureCd(deliveryTargetPrefectureCd: string): void {
        this.setState({
            deliveryTargetPrefectureCd: deliveryTargetPrefectureCd,
        })
    }

    setDeliveryTargetAddress2(deliveryTargetAddress2: string): void {
        this.setState({
            deliveryTargetAddress2: deliveryTargetAddress2,
        })
    }

    handleCloseSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectExcludeCondominium: false})
    }


    onChangeEventCategory(event: SelectChangeEvent<unknown>): void {
        this.setState({
            eventCategory: event.target.value as string,
            eventItem: '',
        })
    }

    onChangeEventItem(event: SelectChangeEvent<unknown>): void {
        this.setState({eventItem: event.target.value as string})
        if (event.target.value) {
            this.setState({title: this.getEventItemLabel(event.target.value as string)})
        }
    }

    getEventItemLabel(eventItemValue: string): string {
        let itemEventItemLabel: string = ''
        switch (this.state.eventCategory) {
            case EVENT_CATEGORY.TRASH_DAY.value:
                const itemEventItemGarbageDayMaster = EVENT_ITEM_GARBAGE_DAY.codeToEnumConstants(eventItemValue)
                if (itemEventItemGarbageDayMaster) {
                    itemEventItemLabel = itemEventItemGarbageDayMaster.label
                }
                break
            case EVENT_CATEGORY.MAINTENANCE.value:
                const itemEventItemMaintenanceMaster = EVENT_ITEM_MAINTENANCE.codeToEnumConstants(eventItemValue)
                if (itemEventItemMaintenanceMaster) {
                    itemEventItemLabel = itemEventItemMaintenanceMaster.label
                }
                break
            case EVENT_CATEGORY.CLEANING.value:
                const itemEventItemCleaningMaster = EVENT_ITEM_CLEANING.codeToEnumConstants(eventItemValue)
                if (itemEventItemCleaningMaster) {
                    itemEventItemLabel = itemEventItemCleaningMaster.label
                }
                break
            case EVENT_CATEGORY.OTHER_EVENT.value:
                const itemEventItemOtherEventsMaster = EVENT_ITEM_OTHER_EVENTS.codeToEnumConstants(eventItemValue)
                if (itemEventItemOtherEventsMaster) {
                    itemEventItemLabel = itemEventItemOtherEventsMaster.label
                }
                break
            case EVENT_CATEGORY.OTHER.value:
                const itemEventItemOtherMaster = EVENT_ITEM_OTHER.codeToEnumConstants(eventItemValue)
                if (itemEventItemOtherMaster) {
                    itemEventItemLabel = itemEventItemOtherMaster.label
                }
                break
            default:
                break
        }
        return itemEventItemLabel
    }

    onChangetitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({title: event.target.value})
    }

    onChangeBarColor(color: ColorResult): void {
        this.setState({tmpBarColor: color.hex})
    }

    onChangeEventTeamType(event: React.ChangeEvent<HTMLInputElement>): void {

        this.setState({
            eventTermType: event.target.value,
            scheduleStartDateMin: this.initialMinDate,
            scheduleStartDateMax: this.initialMaxDate,
            scheduleEndDateMin: this.initialMinDate,
            scheduleEndDateMax: this.initialMaxDate,
            scheduleStartDate: '',
            scheduleEndDate: '',
            eventRepeatUnit: EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value,
            repeatWeekUnit: EVENT_REPEAT_UNIT_FOR_WEEK.EVERY_WEEK.value,
            repeatWeek: JSON.parse(this.initialrepeatWeek),
            repeatDateOfTheWeek: JSON.parse(this.initialrepeatDateOfTheWeek),
            repeatDate: '',
            dateOfEvent: '',
        })

        if (event.target.value === EVENT_TERM_TYPE.ONE_DAY.value) {
            this.setState({
                dateOfEvent: this.initialStartDate,
            })
        } else {
            this.setState({
                scheduleStartDate: this.initialStartDate,
                scheduleEndDate: this.initialEndDate,
            })
        }

    }

    onChangeDayOfEvent(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({dateOfEvent: date.toString()})
        } else {
            this.setState({dateOfEvent: ''})
        }
    }

    onChangeEventStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({scheduleStartDate: date.toString(), scheduleEndDateMin: date.toString()})
        } else {
            this.setState({scheduleStartDate: '', scheduleEndDateMin: getYearDate()})
        }
    }

    onChangescheduleEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({scheduleEndDate: date.toString(), scheduleStartDateMax: date.toString()})
        } else {
            this.setState({scheduleEndDate: '', scheduleStartDateMax: this.state.selectedMaxDateTime})
        }
    }

    onChangeRepeatWeekUnit(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value === EVENT_REPEAT_UNIT_FOR_WEEK.SELECTION_WEEK.value) {
            this.setState({
                repeatWeekUnit: event.target.value,
                repeatWeek: JSON.parse(this.initialrepeatWeek),
            })
        } else {
            this.setState({repeatWeekUnit: event.target.value})
        }
    }

    onChangeEventRepeatUnit(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value === EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value) {
            // 繰り返し週/曜日指定
            this.setState({repeatDate: ''})
        }
        if (event.target.value === EVENT_REPEAT_UNIT.DAY.value) {
            // 繰り返し日指定
            // イベント繰り返し曜日
            const repeatDateOfTheWeek: RepeatWeek[] = []
            EVENT_REPEAT_DAY_OF_THE_WEEK.values().map((repeatDayOfTheWeek) => (
                repeatDateOfTheWeek.push(
                    {
                        id: repeatDayOfTheWeek.value,
                        label: repeatDayOfTheWeek.label,
                        checked: false,
                        displayOrder: repeatDayOfTheWeek.displayOrder,
                    },
                )
            ))
            repeatDateOfTheWeek.push({
                id: 'ALL',
                label: '全ての曜日にチェック',
                checked: false,
                displayOrder: 99,
            })

            this.setState({
                repeatDateOfTheWeek: repeatDateOfTheWeek,
                repeatWeekUnit: EVENT_REPEAT_UNIT_FOR_WEEK.EVERY_WEEK.value,
            })
        }
        this.setState({eventRepeatUnit: event.target.value})
    }


    onChangeRepeatWeek(targetId: string, index: number): void {
        const repeatWeek: RepeatWeek[] = this.state.repeatWeek
        const checked: boolean = repeatWeek[index].checked
        repeatWeek[index].checked = !checked

        this.setState({
            repeatWeek: repeatWeek,
        })
    }

    onChangeRepeatDateOfTheWeek(targetId: string, index: number): void {
        const repeatDateOfTheWeek: RepeatWeek[] = this.state.repeatDateOfTheWeek
        const repeatDateOfTheWeekAllIndex = repeatDateOfTheWeek.length - 1
        const checked: boolean = repeatDateOfTheWeek[index].checked
        if (repeatDateOfTheWeek[index].id === 'ALL') {
            repeatDateOfTheWeek.map((repeatDayOfTheWeek, key) => {
                repeatDateOfTheWeek[key].checked = !checked
            })
        } else {
            // 「全ての曜日にチェック」以外を選択した場合、必ず「全ての曜日にチェック」のチェックを外す
            repeatDateOfTheWeek[index].checked = !checked
            repeatDateOfTheWeek[repeatDateOfTheWeekAllIndex].checked = false
        }
        this.setState({
            repeatDateOfTheWeek: repeatDateOfTheWeek,
        })
    }

    onChangeRepeatDate(event: SelectChangeEvent<unknown>): void {
        this.setState({repeatDate: event.target.value as string})
    }

    onChangeDescription(value: string): void {
        this.setState({description: value})
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        this.setState({selectedCondomoniumGroupId: condomoniumGroupId})

        // 物件グループを変更する度に除外する物件をクリアする
        this.setState({selectedExcludeCondominiumInfo: []})
    }

    // イベント期間指定種別
    getEventTermTypeRadioGroupData(): PPRadioItemProp[] {
        const eventTermTypeRadioGroupData: PPRadioItemProp[] = []
        EVENT_TERM_TYPE.values().map((eventTermType) => (
            eventTermTypeRadioGroupData.push(
                {
                    label: eventTermType.label,
                    value: eventTermType.value,
                    radioProps: {
                        checked: eventTermType.value === this.state.eventTermType,
                        onChange: this.onChangeEventTeamType,
                    },
                },
            )
        ))
        return eventTermTypeRadioGroupData
    }

    // 繰り返し単位
    getEventRepeatUnitRadioGroupData(): PPRadioItemProp[] {
        const eventRepeatUnitRadioGroupData: PPRadioItemProp[] = []
        EVENT_REPEAT_UNIT.values().map((eventRepeatUnit) => (
            eventRepeatUnitRadioGroupData.push(
                {
                    label: eventRepeatUnit.label,
                    value: eventRepeatUnit.value,
                    radioProps: {
                        checked: eventRepeatUnit.value === this.state.eventRepeatUnit,
                        onChange: this.onChangeEventRepeatUnit,

                    },
                },
            )
        ))
        return eventRepeatUnitRadioGroupData
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            let repeatWeek: string = ''
            this.state.repeatWeek.map((week) => {
                if (week.checked) {
                    repeatWeek = repeatWeek + week.id + ','
                }
            })
            if (repeatWeek !== '') {
                repeatWeek = repeatWeek.slice(0, -1)
            }
            let repeatDateOfTheWeek: string = ''
            this.state.repeatDateOfTheWeek.map((repeatDayOfTheWeek) => {
                if (repeatDayOfTheWeek.checked && repeatDayOfTheWeek.id !== 'ALL') {
                    repeatDateOfTheWeek = repeatDateOfTheWeek + repeatDayOfTheWeek.id + ','
                }
            })

            if (repeatDateOfTheWeek !== '') {
                repeatDateOfTheWeek = repeatDateOfTheWeek.slice(0, -1)
            }

            const scheduleNotDeliveryCondominiumList: ScheduleNotDeliveryCondominiumList[] = []
            if (this.state.selectedExcludeCondominiumInfo.length > 0) {
                this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
                    scheduleNotDeliveryCondominiumList.push(
                        {condominiumCd: condominiumInfo.condominiumCd},
                    )
                })
            }

            let scheduleStartDate: string = ''
            if (this.state.eventTermType === EVENT_TERM_TYPE.TERM.value) {
                scheduleStartDate = formatForDateInput(this.state.scheduleStartDate)
            } else {
                scheduleStartDate = formatForDateInput(this.state.dateOfEvent)
            }
            let scheduleEndDate: string = ''
            if (this.state.scheduleEndDate) {
                scheduleEndDate = formatForDateInput(this.state.scheduleEndDate)
            }

            // リクエスト
            const request: NatPutScheduleParams = {
                scheduleId: this.props.scheduleId,
                eventCategory: this.state.eventCategory,
                eventItem: this.state.eventItem,
                title: this.state.title,
                barColorSetting: this.state.barColorSetting,
                description: this.state.description,
                scheduleStartDate: scheduleStartDate,
                eventTermType: this.state.eventTermType,
                version: this.state.version,
            }

            if (this.state.eventTermType === EVENT_TERM_TYPE.TERM.value) {
                // イベント期間指定種別 = 期間指定
                request.scheduleEndDate = scheduleEndDate
                request.eventRepeatUnit = this.state.eventRepeatUnit
                if (this.state.eventRepeatUnit === EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value) {
                    request.repeatWeekUnit = this.state.repeatWeekUnit
                    request.repeatDayOfWeek = repeatDateOfTheWeek
                    // イベント繰り返し単位 = 繰り返し週/曜日指定
                    if (this.state.repeatWeekUnit === EVENT_REPEAT_UNIT_FOR_WEEK.SELECTION_WEEK.value) {
                        // イベント繰り返し週単位 = 週選択
                        request.repeatWeek = repeatWeek
                    }
                } else {
                    // イベント繰り返し単位 = 繰り返し日指定
                    request.repeatDate = this.state.repeatDate
                }
            }

            if (this.state.deliveryTargetAddress2) {
                request.deliveryTargetAddress2 = this.state.deliveryTargetAddress2
            }
            if (this.state.deliveryTargetPrefectureCd) {
                request.deliveryTargetPrefectureCd = this.state.deliveryTargetPrefectureCd
            }
            if (this.state.selectedCondomoniumGroupId) {
                request.condominiumGroupId = this.state.selectedCondomoniumGroupId
                request.scheduleNotDeliveryCondominium = scheduleNotDeliveryCondominiumList
            }

            // スケジュール更新
            const putScheduleResponse: Nullable<NatPutSchedule> = await this.props.asyncCallFunction(
                this.props.scheduleRepo.putSchedule.bind(this.props.scheduleRepo, request),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('スケジュール')},
            )
            if (putScheduleResponse && putScheduleResponse.requestError === null) {
                this.props.navigate(`/admin/schedule/${this.props.scheduleId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString('スケジュール', this.state.title),
                            },
                        },
                    },
                )
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // イベントカテゴリ
    getEventCategoryList(): OptionProps[] {
        let categories: OptionProps[]

        categories = EVENT_CATEGORY.values().map((category) => {
            return ({
                label: `${category.label}`,
                value: `${category.value}`,
            })
        })
        return categories
    }

    // イベント項目
    getEventItemList(): OptionProps[] {
        let items: OptionProps[] = []

        switch (this.state.eventCategory) {
            case EVENT_CATEGORY.TRASH_DAY.value:
                items = EVENT_ITEM_GARBAGE_DAY.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            case EVENT_CATEGORY.MAINTENANCE.value:
                items = EVENT_ITEM_MAINTENANCE.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            case EVENT_CATEGORY.CLEANING.value:
                items = EVENT_ITEM_CLEANING.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            case EVENT_CATEGORY.OTHER_EVENT.value:
                items = EVENT_ITEM_OTHER_EVENTS.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            case EVENT_CATEGORY.OTHER.value:
                items = EVENT_ITEM_OTHER.values().map((item) => {
                    return ({
                        label: `${item.label}`,
                        value: `${item.value}`,
                    })
                })
                break
            default:
                break
        }

        return [{
            label: '項目を選択してください',
            value: '',
        }, ...items]
    }


    // 繰り返し週単位
    getrepeatWeekUnitRadioGroupData(): PPRadioItemProp[] {
        const repeatWeekUnitRadioGroupData: PPRadioItemProp[] = []
        EVENT_REPEAT_UNIT_FOR_WEEK.values().map((repeatWeekUnit) => (
            repeatWeekUnitRadioGroupData.push(
                {
                    label: repeatWeekUnit.label,
                    value: repeatWeekUnit.value,
                    radioProps: {
                        checked: repeatWeekUnit.value === this.state.repeatWeekUnit,
                        onChange: this.onChangeRepeatWeekUnit,
                    },
                },
            )
        ))
        return repeatWeekUnitRadioGroupData
    }


    // 繰り返し日
    getrepeatDate(): OptionProps[] {
        let repeatDates: OptionProps[]

        repeatDates = EVENT_REPEAT_DAY.values().map((repeatDate) => {
            return ({
                label: `${repeatDate.label}`,
                value: `${repeatDate.value}`,
            })
        })
        return [{
            label: '繰り返し日を指定してください',
            value: '',
        }, ...repeatDates]
    }

    setSelectedExclusionCondominiumInfo(selectedExcludeCondominiumInfo: DeliveryCondominiumList[]): void {
        selectedExcludeCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            dialogOpenSelectExcludeCondominium: false,
        })
    }

    async registerScheduleButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WNTFA0001.errorLevel,
                message: Messages.WNTFA0001.toString(''),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    judgRegisterScheduleButton(): boolean {
        let disabled: boolean = true

        // 全体モード
        if (this.administratorMode === ADMINISTORATOR_MODE.ALL.value &&
            this.state.selectedCondomoniumGroupId === null) {
            return true
        }
        if (this.state.eventCategory !== '' &&
            this.state.eventItem !== '' &&
            this.state.title !== '' &&
            this.state.eventTermType !== '') {
            // イベント期間指定種別が、単日指定の場合
            if (this.state.eventTermType === EVENT_TERM_TYPE.ONE_DAY.value) {
                if (this.state.dateOfEvent !== '') {
                    disabled = false
                }
            } else {
                // イベント期間指定種別が、期間指定の場合
                if (this.state.scheduleStartDate !== '' &&
                    this.state.scheduleEndDate !== '' &&
                    this.state.eventRepeatUnit !== '') {
                    // イベント繰り返し単位が、繰り返し週/曜日指定の場合
                    if (this.state.eventRepeatUnit === EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value) {
                        if (this.state.repeatWeekUnit !== '') {
                            // イベント繰り返し週単位が、週選択の場合
                            if (this.state.repeatWeekUnit === EVENT_REPEAT_UNIT_FOR_WEEK.SELECTION_WEEK.value) {
                                this.state.repeatWeek.some((repeatWeek) => {
                                    if (repeatWeek.checked) {
                                        disabled = false
                                        return true
                                    }
                                })
                                if (!disabled) {
                                    disabled = true
                                    this.state.repeatDateOfTheWeek.some((repeatDayOfTheWeek) => {
                                        if (repeatDayOfTheWeek.checked) {
                                            disabled = false
                                            return true
                                        }
                                    })
                                }
                            } else {
                                disabled = true
                                this.state.repeatDateOfTheWeek.some((repeatDayOfTheWeek) => {
                                    if (repeatDayOfTheWeek.checked) {
                                        disabled = false
                                        return true
                                    }
                                })
                            }
                        }
                    } else {
                        // イベント繰り返し単位が、繰り返し日指定の場合
                        if (this.state.repeatDate) {
                            disabled = false
                        }
                    }
                }
            }
        }
        return disabled
    }

    deleteExcludeCondominium(condominiumCd: string): void {
        const selectedExcludeCondominiumInfo: DeliveryCondominiumList[] = []
        this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
            if (condominiumInfo.condominiumCd !== condominiumCd) {
                selectedExcludeCondominiumInfo.push(condominiumInfo)
            }
        })
        this.setState({selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo})
    }

    // 繰り返し週
    renderEventRepeatUnitWeek(): ReactElement {
        return (
            <>
                {this.state.repeatWeek.map((week, index) => (
                    <PPCheckboxGroup
                        data={[{
                            label: week.label,
                            checked: week.checked,
                        }]}
                        onChange={() => this.onChangeRepeatWeek(week.id, index)}
                    />
                ))}
            </>
        )
    }

    // 曜日
    renderrepeatDateOfTheWeek(): ReactElement {
        return (
            <>
                {this.state.repeatDateOfTheWeek.map((week, index) => (
                    <PPCheckboxGroup
                        key={`week_${index}`}
                        data={[{
                            label: week.label,
                            checked: week.checked,
                        }]}
                        onChange={() => this.onChangeRepeatDateOfTheWeek(week.id, index)}
                    />
                ))}
            </>
        )
    }

    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>スケジュール情報</StyledTableCaption>
                    <TableBody>
                        {(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                            <>
                                <TableRow>
                                    <TableRowName required>掲載範囲</TableRowName>
                                    {
                                        this.state.condominiumGroup &&
                                        this.state.condominiumGroup.details &&
                                        <>
                                            <TableRowName>物件グループ</TableRowName>
                                            <TableCell>
                                                <NatCondominiumGroupSelectComponent
                                                    condominiumGroup={this.state.condominiumGroup.details}
                                                    defaultValue={(this.state.selectedCondomoniumGroupId) ?
                                                        this.state.selectedCondomoniumGroupId :
                                                        this.state.loginUserCondominiumGroupId}
                                                    onChangeSelectedCondominiumGroupId=
                                                        {this.onChangeSelectedCondominiumGroupId}
                                                    requiredFlag={true}
                                                    eventKeys={['condominiumGroupId']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    autoFocus={true}
                                                >
                                                </NatCondominiumGroupSelectComponent>
                                            </TableCell>
                                        </>
                                    }

                                </TableRow>
                                {this.renderDeliveryTargetArea()}
                                <TableRow>
                                    <TableRowName rowSpan={this.state.selectedExcludeCondominiumInfo.length + 1}>
                                        除外する物件を選択
                                    </TableRowName>
                                    <TableCell colSpan={4}>
                                        <AdminDefaultMediumButton
                                            onClick={this.handleOpenExclusionCondominiumSelectionDialog}
                                            size={'small'}
                                        >
                                            物件を選択
                                        </AdminDefaultMediumButton>
                                    </TableCell>
                                </TableRow>
                                {this.state.dialogOpenSelectExcludeCondominium && this.state.condominiumGroup.details &&
                                    <NatCondominiumSelectionComponent
                                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                                        condominiumRepo={this.props.condominiumRepo}
                                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                                        closeSelectCondominiumDiaLog={this.handleCloseSelectCondominiumDiaLog}
                                        setSelectedExclusionCondominiumInfo={this.setSelectedExclusionCondominiumInfo}
                                        eventEmitter={this.props.eventEmitter}
                                        selectedCondominiumGroupId={this.state.selectedCondomoniumGroupId}
                                        navigate={this.props.navigate}
                                        location={this.props.location}
                                        asyncCallFunction={this.props.asyncCallFunction}
                                        excludeCondominium={this.state.selectedExcludeCondominiumInfo}
                                    />
                                }
                                {this.state.selectedExcludeCondominiumInfo.length > 0 &&
                                    this.state.selectedExcludeCondominiumInfo.map((condominiumInfo, index) => {
                                        return (
                                            <TableRow>
                                                <TableCell colSpan={4}>
                                                    <LeftRowFlexContainer>
                                                        <SelectedNotDeliveryCondominium>
                                                            <PPInput
                                                                type="label"
                                                                value={condominiumInfo.condominiumCd +
                                                                    ' ' + condominiumInfo.condominiumName}
                                                                eventKeys={[`scheduleNotDeliveryCondominium[${index}].condominiumCd`]}
                                                                eventEmitter={this.props.eventEmitter}
                                                            />
                                                        </SelectedNotDeliveryCondominium>
                                                        <SelectedNotDeliveryCondominium>
                                                            <DeleteLink onClick={(event: React.MouseEvent) => {
                                                                event.preventDefault()
                                                                this.deleteExcludeCondominium(
                                                                    condominiumInfo.condominiumCd,
                                                                )
                                                            }}>
                                                                削除
                                                            </DeleteLink>
                                                        </SelectedNotDeliveryCondominium>
                                                    </LeftRowFlexContainer>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </> : null
                        }
                        <TableRow>
                            <TableRowName required>イベントカテゴリ</TableRowName>
                            <TableCell colSpan={4}>
                                <PPSelect
                                    data={this.getEventCategoryList()}
                                    onChange={this.onChangeEventCategory}
                                    eventKeys={['eventCategory']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.eventCategory}
                                    autoFocus={(this.administratorMode === ADMINISTORATOR_MODE.ALL.value) ?
                                        false : true}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>イベント項目</TableRowName>
                            <TableCell colSpan={4}>
                                <PPSelect
                                    data={this.getEventItemList()}
                                    onChange={this.onChangeEventItem}
                                    eventKeys={['eventItem']}
                                    eventEmitter={this.props.eventEmitter}
                                    value={this.state.eventItem}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={this.state.title}
                                    onChange={this.onChangetitle}
                                    eventKeys={['title']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>バー色指定</TableRowName>
                            <StyledTableCell colSpan={4}>
                                <Square color={this.state.barColorSetting}>
                                    <PPErrorDisplayButton
                                        component={'span'}
                                        disabled={false}
                                        size={'small'}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['barColorSetting']}
                                        onClick={this.handleOpenColorSetting}
                                        clearError={true}
                                    >
                                        {''}
                                    </PPErrorDisplayButton>
                                </Square>

                                <Dialog
                                    open={this.state.open}
                                    fullWidth={false}
                                >
                                    <StyledSketchPicker
                                        color={this.state.tmpBarColor}
                                        onChangeComplete={this.onChangeBarColor}
                                    />
                                    <StyledDialogActions>
                                        <StyledDialogCancelButton
                                            color="primary"
                                            onClick={this.handleCancelColorSetting}
                                        >
                                            キャンセル
                                        </StyledDialogCancelButton>
                                        <StyledDialogOkButton
                                            color="primary"
                                            onClick={this.handleOkColorSetting}
                                        >
                                            OK
                                        </StyledDialogOkButton>
                                    </StyledDialogActions>
                                </Dialog>
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required rowSpan={2}>期間</TableRowName>
                            <StyledColSpan colSpan={4}>
                                <PPRadioGroup
                                    name={'eventTermType'}
                                    row
                                    data={this.getEventTermTypeRadioGroupData()}
                                    eventKeys={['eventTermType']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </StyledColSpan>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={4} style={{paddingBottom: 18, paddingTop: 22}}>
                                <LeftRowFlexContainer>
                                    {(this.state.eventTermType === EVENT_TERM_TYPE.ONE_DAY.value) ?
                                        <TermWrapper>
                                            <PPDatePicker
                                                key={'scheduleStartDateOneDay'}
                                                onChangeDate={this.onChangeDayOfEvent}
                                                value={(this.state.dateOfEvent !== '') ?
                                                    new Date(this.state.dateOfEvent) : null
                                                }
                                                minDate={(this.state.scheduleEndDateMin !== '') ?
                                                    new Date(this.state.scheduleEndDateMin) : undefined
                                                }
                                                maxDate={(this.state.scheduleEndDateMax !== '') ?
                                                    new Date(this.state.scheduleEndDateMax) : undefined
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['scheduleStartDate']}
                                            />
                                        </TermWrapper> :
                                        <>
                                            <TermWrapper>
                                                <FlexBasis>
                                                    <PPDatePicker
                                                        key={'scheduleStartDateTermDay'}
                                                        onChangeDate={this.onChangeEventStartDate}
                                                        value={(this.state.scheduleStartDate !== '') ?
                                                            new Date(this.state.scheduleStartDate) : null
                                                        }
                                                        minDate={(this.state.scheduleStartDateMin !== '') ?
                                                            new Date(this.state.scheduleStartDateMin) : null
                                                        }
                                                        maxDate={(this.state.scheduleStartDateMax !== '') ?
                                                            new Date(this.state.scheduleStartDateMax) : null
                                                        }
                                                        eventEmitter={this.props.eventEmitter}
                                                        eventKeys={['scheduleStartDate']}
                                                    />
                                                </FlexBasis>
                                            </TermWrapper>
                                            <TermTxt>から</TermTxt>
                                            <TermWrapper>
                                                <FlexBasis>
                                                    <PPDatePicker
                                                        key={'scheduleEndDateTermDay'}
                                                        onChangeDate={this.onChangescheduleEndDate}
                                                        value={(this.state.scheduleEndDate !== '') ?
                                                            new Date(this.state.scheduleEndDate) : null
                                                        }
                                                        minDate={(this.state.scheduleEndDateMin !== '') ?
                                                            new Date(this.state.scheduleEndDateMin) : null
                                                        }
                                                        maxDate={(this.state.scheduleEndDateMax !== '') ?
                                                            new Date(this.state.scheduleEndDateMax) : null
                                                        }
                                                        eventEmitter={this.props.eventEmitter}
                                                        eventKeys={['scheduleEndDate']}
                                                    />
                                                </FlexBasis>
                                                <TermTxt>まで</TermTxt>
                                            </TermWrapper>
                                        </>
                                    }
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {(this.state.eventTermType === EVENT_TERM_TYPE.TERM.value) ?
                            <>
                                <TableRow>
                                    <TableRowName required>繰り返し設定</TableRowName>
                                    <TableCell colSpan={4} style={{paddingBottom: 8, paddingTop: 11}}>
                                        <RepeatUl>
                                            <PPRadioGroup
                                                name={'repeatUnit'}
                                                row
                                                data={this.getEventRepeatUnitRadioGroupData()}
                                                eventKeys={['eventRepeatUnit']}
                                                eventEmitter={this.props.eventEmitter}
                                            />
                                            {(this.state.eventRepeatUnit ===
                                                EVENT_REPEAT_UNIT.WEEK_OR_DAY_OF_WEEK.value) ?
                                                <>
                                                    <ul>
                                                        繰り返し単位設定
                                                        <ul>
                                                            <PPRadioGroup
                                                                name={'repeatUnitForWeek'}
                                                                row
                                                                data={this.getrepeatWeekUnitRadioGroupData()}
                                                                eventKeys={['repeatWeekUnit']}
                                                                eventEmitter={this.props.eventEmitter}
                                                            />
                                                            {(this.state.repeatWeekUnit ===
                                                                EVENT_REPEAT_UNIT_FOR_WEEK.SELECTION_WEEK.value) ?
                                                                <>
                                                                    <ul>
                                                                        <LeftRowFlexContainer>
                                                                            {this.renderEventRepeatUnitWeek()}
                                                                        </LeftRowFlexContainer>
                                                                    </ul>
                                                                </> : null
                                                            }

                                                        </ul>
                                                        曜日指定
                                                        <ul>
                                                            <LeftRowFlexContainer>
                                                                {this.renderrepeatDateOfTheWeek()}
                                                            </LeftRowFlexContainer>
                                                        </ul>
                                                    </ul>
                                                </> :
                                                <>
                                                    <PPSelect
                                                        data={this.getrepeatDate()}
                                                        onChange={this.onChangeRepeatDate}
                                                        eventKeys={['repeatDate']}
                                                        eventEmitter={this.props.eventEmitter}
                                                        value={this.state.repeatDate}
                                                    />
                                                </>
                                            }
                                        </RepeatUl>
                                    </TableCell>
                                </TableRow>
                            </> : null
                        }
                        <TableRow>
                            <TableRowName>説明文</TableRowName>
                            <TableCell colSpan={4}>
                                <PPHtmlEditor
                                    value={this.state.description}
                                    onEditorChange={this.onChangeDescription}
                                    eventKeys={['description']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgRegisterScheduleButton()}
                        onClick={this.registerScheduleButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            '/admin/calendar',
                        )}
                    >
                        スケジュール参照へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderDeliveryTargetArea(): ReactNode {

        return (
            <>
                <TableRow>
                    <TableRowName>
                        配信対象を地域から選択
                    </TableRowName>
                    <TableCell colSpan={3}>
                        <LeftRowFlexContainer>
                            <AdminDefaultMediumButton
                                onClick={this.handleOpenDeliveryTargetAreaSelectionDialog}
                                size={'small'}
                            >
                                地域を選択
                            </AdminDefaultMediumButton>
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeliveryTargetArea>
                                    <DeliveryTargetAreaTxt>
                                        {` 指定地域: `
                                            + this.getPrefectureName(this.state.deliveryTargetPrefectureCd)
                                            + this.state.deliveryTargetAddress2
                                        }
                                    </DeliveryTargetAreaTxt>
                                </DeliveryTargetArea>
                                : ``
                            }
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeleteLink onClick={(event: React.MouseEvent) => {
                                    event.preventDefault()
                                    this.setState({
                                        deliveryTargetPrefectureCd: '',
                                        deliveryTargetAddress2: '',
                                        selectedDeliveryTargetCondominiumInfo: [],
                                    })
                                }}>
                                    削除
                                </DeleteLink>
                                : ''
                            }
                        </LeftRowFlexContainer>
                        {this.state.dialogOpenSelectDeliveryTargetArea && this.state.condominiumGroup.details &&
                            <NatDeliveryTargetAreaSelectionComponent
                                condominiumRepo={this.props.condominiumRepo}
                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                closeSelectDeliveryTargetAreaDiaLog=
                                    {this.handleCloseDeliveryTargetAreaSelectionDialog}
                                setSelectedDeliveryTargetCondominiumInfo=
                                    {this.setSelectedDeliveryTargetCondominiumInfo}
                                setDeliveryTargetPrefectureCd={this.setDeliveryTargetPrefectureCd}
                                setDeliveryTargetAddress2={this.setDeliveryTargetAddress2}
                                eventEmitter={this.props.eventEmitter}
                                selectedCondominiumGroupId={this.state.selectedCondomoniumGroupId}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {
                            <InnerMiniTable>
                                <InnerMiniTableBody>
                                    {this.state.selectedDeliveryTargetCondominiumInfo.map(
                                        (condominiumInfo, index) => {
                                            return (
                                                <TableRow key={condominiumInfo.condominiumCd}>
                                                    <InnerMiniTableCell>
                                                        {condominiumInfo.condominiumCd + ' ' +
                                                            condominiumInfo.condominiumName}
                                                        <PPErrorLabel
                                                            eventEmitter={this.props.eventEmitter}
                                                            eventKeys={[`messageDeliveryTargetCondominium
                                                            [${index}].condominiumCd`]}
                                                        />
                                                    </InnerMiniTableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </InnerMiniTableBody>
                            </InnerMiniTable>
                        }
                    </TableCell>
                </TableRow>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export default createAdminPage(NatAdminScheduleUpdatePage)

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root input {
    width: 100px;
    font-size: 36px;

    &::before {
      content: initial;
    }

    &::after {
      content: initial;
    }
  }

  &.MuiTableCell-root .MuiInput-underline {
    &::before {
      content: initial;
    }

    &::after {
      content: initial;
    }
  }
`
const StyledColSpan = styled(TableCell)`
  &.MuiTableCell-root {
    border-bottom: initial;
    padding: 14px 12px 0 12px;
`


const DeliveryTargetAreaTxt: StyledSpan = styled.span`
  font-weight: ${FontWeights.Bold};
`
const DeliveryTargetArea: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

interface SquareProps {
    color: string;
}

const Square: StyledDiv = styled.div<SquareProps>`
  & .MuiButton-contained {
    border-radius: 10px;
    width: 100px;
    height: 40px;
    ${props => props.color ? `
      background-color: ${props.color};
    ` : `background-color: initial; box-shadow: initial;`};
    cursor: pointer;
  }

  & .MuiButton-contained:hover, .MuiButton-root:hover {
    ${props => props.color ? `
        background-color: ${props.color};
        ` : `background-color: initial; box-shadow: initial; cursor: initial`};
  }
`

const RepeatUl: StyledUl = styled.ul`
  padding: 0;
  margin: 0;

`

const StyledSketchPicker = styled(SketchPicker)`
  &.sketch-picker {
    width: 250px !important;
    border-radius: 0 !important;
  }
`


const StyledDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    background-color: ${Colors.Surface};
`

const StyledDialogOkButton = styled(Button)`
  margin-left: auto;

  &.MuiButton-root {
    flex: 1 1 0%;
  }
`


const StyledDialogCancelButton = styled(Button)`
  margin-right: auto;

  &.MuiButton-root {
    flex: 1 1 0%;
  }
`


const SelectedNotDeliveryCondominium: StyledLabel = styled.label`
  white-space: nowrap;
  padding-left: 15px;
  padding-right: 15px;

  & .MuiInput-underline:before {
    border-bottom: none;
  }

  & .MuiInput-underline.Mui-error:after {
    border-bottom: none;
  }
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
